// Detailed mode enriched sections (mode === "detaillee").
// Extracted verbatim from SyntheseMarchesPage.js - no visual changes.
import {
  CheckCircle2,
  AlertTriangle,
  Sparkles,
  Zap,
  ClipboardList,
} from 'lucide-react';
import { formatValue } from './utils';

const renderItem = (item) =>
  typeof item === 'string' ? item : formatValue(item);

export default function DetailedSections({ result }) {
  if (!result || Object.keys(result).length === 0) return null;

  return (
    <>
      {/* Exigences techniques */}
      {Array.isArray(result.exigences_techniques) && result.exigences_techniques.length > 0 && (
        <div data-testid="result-exigences-techniques">
          <h3 className="font-semibold text-slate-900 mb-2 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-cyan-500" />
            Exigences techniques
          </h3>
          <ul className="space-y-2">
            {result.exigences_techniques.map((item, i) => (
              <li key={`item-${i}`} className="flex items-start gap-2 text-cyan-800 bg-cyan-50 p-3 rounded-lg border border-cyan-200">
                <CheckCircle2 className="w-5 h-5 text-cyan-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{renderItem(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Clauses juridiques */}
      {Array.isArray(result.clauses_juridiques) && result.clauses_juridiques.length > 0 && (
        <div data-testid="result-clauses-juridiques">
          <h3 className="font-semibold text-slate-900 mb-2 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-indigo-500" />
            Clauses juridiques
          </h3>
          <ul className="space-y-2">
            {result.clauses_juridiques.map((item, i) => (
              <li key={`item-${i}`} className="text-indigo-900 bg-indigo-50 p-3 rounded-lg border border-indigo-200 text-sm whitespace-pre-line">
                {renderItem(item)}
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Recommandations stratégiques */}
      {Array.isArray(result.recommandations_strategiques) && result.recommandations_strategiques.length > 0 && (
        <div data-testid="result-recommandations">
          <h3 className="font-semibold text-slate-900 mb-2 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-emerald-500" />
            Recommandations stratégiques
          </h3>
          <ul className="space-y-2">
            {result.recommandations_strategiques.map((item, i) => (
              <li key={`item-${i}`} className="flex items-start gap-2 text-emerald-800 bg-emerald-50 p-3 rounded-lg border border-emerald-200">
                <Sparkles className="w-5 h-5 text-emerald-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{renderItem(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Atouts à valoriser */}
      {Array.isArray(result.atouts_a_valoriser) && result.atouts_a_valoriser.length > 0 && (
        <div data-testid="result-atouts">
          <h3 className="font-semibold text-slate-900 mb-2 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-violet-500" />
            Atouts à valoriser
          </h3>
          <ul className="space-y-2">
            {result.atouts_a_valoriser.map((item, i) => (
              <li key={`item-${i}`} className="flex items-start gap-2 text-violet-800 bg-violet-50 p-3 rounded-lg border border-violet-200">
                <Zap className="w-5 h-5 text-violet-500 mt-0.5 flex-shrink-0" />
                <span className="text-sm">{renderItem(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Points de vigilance */}
      {Array.isArray(result.points_de_vigilance) && result.points_de_vigilance.length > 0 && (
        <div data-testid="result-points-vigilance" className="bg-red-50 p-4 rounded-xl border border-red-200">
          <h3 className="font-semibold text-red-700 mb-2 flex items-center gap-2">
            <AlertTriangle className="w-4 h-4" />
            Points de vigilance
          </h3>
          <ul className="space-y-2">
            {result.points_de_vigilance.map((item, i) => (
              <li key={`item-${i}`} className="flex items-start gap-2 text-red-800 text-sm">
                <span className="text-red-500 mt-1">•</span>
                <span>{renderItem(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      {/* Checklist complète */}
      {Array.isArray(result.checklist_complete) && result.checklist_complete.length > 0 && (
        <div data-testid="result-checklist">
          <h3 className="font-semibold text-slate-900 mb-2 flex items-center gap-2">
            <div className="w-2 h-2 rounded-full bg-amber-500" />
            Checklist complète de réponse
          </h3>
          <ul className="space-y-1 bg-amber-50 p-4 rounded-xl border border-amber-200">
            {result.checklist_complete.map((item, i) => (
              <li key={`item-${i}`} className="flex items-start gap-2 text-amber-900 text-sm">
                <ClipboardList className="w-4 h-4 mt-0.5 flex-shrink-0 text-amber-600" />
                <span>{renderItem(item)}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
}
